export default __webpack_public_path__ + "static/media/tollgate.6a4a2f9b.svg";